

export default class {
    constructor(windowPal) {
        this.windowPal = windowPal;
        this.blocks = [];
        this._initWindowPos = null;
        windowPal.scroll(()=>{
            // console.log('scrolled');
            this.refresh();
        });
        setTimeout(()=>{
            this.loadAllBgs();
        }, 5000);
    }
    refresh() {
        // console.log(topPos, height, bottomPos);
        this.blocks.forEach((block, i)=>{
            block.refresh(this.windowMargins());
        });
    }
    loadAllBgs() {
        this.blocks.forEach((block, i)=>{
            block.loadBg();
        });
    }
    windowMargins() {
        let $window = this.windowPal.$,
            upper = $window.scrollTop(),
            height = $window.outerHeight(),
            lower = upper + height;
        return new WindowMargins(upper, lower);
    }
    addBlock(block) {
        this.blocks.push(block);
    }
    initMargins() {
        if (this._initWindowPos === null) {
            this._initWindowPos = this.windowMargins();
        }
        return this._initWindowPos;
    }
}


class WindowMargins {
    constructor(upper, lower) {
        this.upper = upper;
        this.lower = lower;
        this.load = {
            upper: upper - this.MARGIN_LOAD,
            lower: lower + this.MARGIN_LOAD,
        };
        this.show = {
            upper: upper - this.MARGIN_SHOW,
            lower: lower + this.MARGIN_SHOW,
        };
    }
    within(margin, pos) {
        return (pos > this[margin].upper && pos < this[margin].lower);
    }
    outside(margin, top, bottom) {
        return (top < this[margin].upper && bottom > this[margin].lower);
    }
}
WindowMargins.prototype.MARGIN_LOAD = 800;
WindowMargins.prototype.MARGIN_SHOW = 20;



// WEBPACK FOOTER //
// ./scripts/lib/ScrollWatcher.js